import { render, staticRenderFns } from "./BuyerBankForm.vue?vue&type=template&id=0fafd4a3&scoped=true&"
import script from "./BuyerBankForm.vue?vue&type=script&lang=js&"
export * from "./BuyerBankForm.vue?vue&type=script&lang=js&"
import style0 from "./BuyerBankForm.vue?vue&type=style&index=0&id=0fafd4a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafd4a3",
  null
  
)

export default component.exports